import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { transactionsPerson } from 'integration/generated/transactions';
import useSWR from 'swr';

const GET_USER_INTERESTS_DATA_KEY = 'GET_USER_INTERESTS_DATA_KEY';

const fetcherPersonPreferencesBySelf =
	(pub: boolean) =>
	async (storeId: string, query: Record<string, unknown>, params: Record<string, unknown>) =>
		await transactionsPerson(pub).personPreferencesBySelf(storeId, query, params);

export const useGetUserInterests = (executed = true) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const params = useExtraRequestParameters();

	const { storeId, langId } = getClientSideCommon(settings, router);

	const baseQuery = useSWR(
		storeId && executed
			? [
					{ storeId, query: { langId, responseFormat: 'json' }, params },
					GET_USER_INTERESTS_DATA_KEY,
			  ]
			: null,
		async ([props]) =>
			fetcherPersonPreferencesBySelf(true)(props.storeId, props.query, props.params)
	);

	return { ...baseQuery, data: baseQuery.data?.userPreferences || [] };
};
